(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');

    // click-directive to show extraday-edit window
    module.directive('extradaysShow', ['$rootScope', 'DayService', 'AgendaBroadcast', ExtradaysShowFn]);

    function ExtradaysShowFn($rootScope, DayService, AgendaBroadcast) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                date: '=', // selected day
                userId: '=', // selected client
                dateEditable: '=?' // is the date range editable                
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                show();
            });

            // show info
            function show() {
                var modalInstance = DayService.showModal(scope.date, scope.dateEditable, scope.userId);

                // get result from modal window (on close)
                // modalInstance.result.then(function (result) {                      
                // });

            }

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });
        }
    }
})();